module.exports = __webpack_public_path__ + "static/media/230BL.2262f1eb.jpg";